export const getStorageOffer = () => {
    return localStorage.getItem('offer') || ''
}

export const setStorageOffer = (offer: any) => {
    localStorage.setItem('offer', JSON.stringify(offer));
}